<template lang="html">
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 129 129" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g>
      <path d="m21.4,99.8c-1.7,0.5-2.9,2.1-2.9,3.9v14.6c0,2.3 1.8,4.1 4.1,4.1h83.8c2.3,0 4.1-1.8 4.1-4.1v-14.6c0-1.8-1.2-3.4-2.9-3.9-1.4-15.7-11.2-28.9-24.8-35.3 13.6-6.4 23.4-19.6 24.8-35.3 1.7-0.5 2.9-2.1 2.9-3.9v-14.6c0-2.3-1.8-4.1-4.1-4.1h-83.8c-2.3,0-4.1,1.8-4.1,4.1v14.6c0,1.8 1.2,3.4 2.9,3.9 1.4,15.7 11.2,28.9 24.8,35.3-13.7,6.4-23.4,19.6-24.8,35.3zm80.9,14.4h-75.6v-6.4h75.5v6.4zm-75.5-99.4h75.5v6.4h-75.5v-6.4zm2.9,14.6h69.7c-2,17.4-16.9,31-34.9,31s-32.7-13.6-34.8-31zm34.9,39.2c18,0 32.8,13.6 34.9,31h-69.8c2.1-17.4 16.9-31 34.9-31z"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Wait'
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/icons/Wait.vue